//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'Card',
  props: ['data', 'favourites'],

  data() {
    return {
      // data: [{}],
    };
  },


  methods: {

    setFav: function() {
      this.$emit('setFavourite');
    },

    isFavourite: function() {
      return this.favourites.find(item =>  {
        return item.toString() === this.data.postid.toString();
        }
      );
    },
  },

};



// WEBPACK FOOTER //
// ./scripts/vue/Card.vue